import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import * as moment from 'moment';




@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html'
})
export class BottomSheetComponent implements OnInit {
  search: any = {};
  today_date: any = new Date();
  lastPageData: any = {}
  monthlyWorkReport: any = []
  assignDistArray: any = []
  years: number[] = [];
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any, public service: DatabaseService, private bottomSheetRef: MatBottomSheetRef<BottomSheetComponent>, public toast: ToastrManager) {
    this.lastPageData = data;
    const startYear = this.today_date.getFullYear() - 2; // Two years back
    const endYear = this.today_date.getFullYear(); // Current year
    this.years = Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i);

    console.log('====================================');
    console.log(data);
    console.log('====================================');
    if (this.lastPageData.filterPage == 'Expense') {
      this.getSalesUser('');
    }
    if (this.lastPageData.filterPage == 'leadReport'|| this.lastPageData.filterPage == 'expenseReport'|| this.lastPageData.filterPage == 'daily_travel_plan_report' || this.lastPageData.filterPage == 'MonthlyProjectionReport' || this.lastPageData.filterPage == 'monthly' || this.lastPageData.filterPage == 'Quartely'|| this.lastPageData.filterPage == 'target_page' || this.lastPageData.filterPage == 'chart'|| this.lastPageData.filterPage == 'pop_gift_page') {
      this.getSalesUser('');
    }
    if (this.lastPageData.filterPage == 'product_wise_secondary_report') {
      this.getSalesUser('');
    }

  }

  ngOnInit() {
  }
  public date(date) {
    if (this.search.date_from) {
      this.search.date_from = moment(this.search.date_from).format('YYYY-MM-DD');
    }
    if (this.search.date_to) {
      this.search.date_to = moment(this.search.date_to).format('YYYY-MM-DD');
    }
  }
  salesUser: any = [];
  getSalesUser(searchValue) {
    let header;
    if (this.lastPageData.filterPage == 'Expense') {
      header = 'Expense/salesUserListExpense';
    }
    if (this.lastPageData.filterPage == 'product_wise_secondary_report' || this.lastPageData.filterPage == 'leadReport' || this.lastPageData.filterPage == 'expenseReport' || this.lastPageData.filterPage == 'daily_travel_plan_report' || this.lastPageData.filterPage == 'MonthlyProjectionReport' || this.lastPageData.filterPage == 'monthly' || this.lastPageData.filterPage == 'Quartely' || this.lastPageData.filterPage == 'target_page' || this.lastPageData.filterPage == 'chart' || this.lastPageData.filterPage == 'pop_gift_page' ) {
      header = 'Expense/salesUserList';
    }
    this.service.post_rqst({ 'search': searchValue }, header).subscribe((response => {
      if (response['statusCode'] == 200) {
        this.salesUser = response['all_sales_user'];
        if (this.lastPageData.filterPage == 'product_wise_secondary_report') {
          this.salesUser.unshift({ 'id': 'All', 'name': 'All', 'role_name': '' })
        }
      } else {
        this.toast.errorToastr(response['statusMsg']);
      }
    }));
  }


  getAssignDistributorOfSalesman(value) {
    this.service.post_rqst({ 'userId': this.data.assigned_sales_user_name, 'search': value }, "Reports/distributorAssign").subscribe((result => {
        if (result['statusCode'] == 200) {
            this.assignDistArray = result['result'];
        }
        else {
            this.toast.errorToastr(result['statusMsg']);
        }
    }));
}
onYearOrQuarterChange(): void {
  const year = this.search.year;
  const quarter = this.search.quarter;

  if (!year || !quarter) {
    this.search.date_from = null;
    this.search.date_to = null;
    return;
  }

  let dateFrom: Date;
  let dateTo: Date;

  // For Q1, use the next year (January-March of the following year)
  if (quarter == 1) {
    dateFrom = new Date(parseInt(year) + 1, 0, 1); // January 1 of next year
    dateTo = new Date(parseInt(year) + 1, 2, 31); // March 31 of next year
  } else if (quarter == 2) {
    dateFrom = new Date(year, 3, 1); // April 1
    dateTo = new Date(year, 5, 30); // June 30
  } else if (quarter == 3) {
    dateFrom = new Date(year, 6, 1); // July 1
    dateTo = new Date(year, 8, 30); // September 30
  } else if (quarter == 4) {
    dateFrom = new Date(year, 9, 1); // October 1
    dateTo = new Date(year, 11, 31); // December 31
  } else {
    dateFrom = null;
    dateTo = null;
  }

  // Format and assign the dates
  this.search.date_from = this.formatDate(dateFrom);
  this.search.date_to = this.formatDate(dateTo);

  console.log('Date From:', this.search.date_from);
  console.log('Date To:', this.search.date_to);
}


formatDate(date: Date): string {
  console.log(date)
  if (!date) return null;
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}

  getValue() {
    this.bottomSheetRef.dismiss(this.search);
  }
}
